import { defineComponent as _defineComponent } from 'vue'
import UserInfoDataService from "@/services/UserInfoDataService";
import UserLinkNavigation from "../../UserLinkNavigationContainer.vue";
import ResponseData from "@/types/ResponseData";
import { ref, onMounted, onUpdated, reactive } from "vue";
import Alert from "../parts/Alert.vue";
import Navigation from "../../NavigationContainer.vue";
import Loading from "@/components/home/Loading";
import SendEmailService from "@/services/SendEmailService";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const getData = ref(false);

const isLoading = ref(false);
const permissionDetail = reactive([]);
const cur_perm_list = reactive([]);
const reapp_perm_list = reactive([]);
const userPermissionInfo = reactive([]);
const statusPermisList = reactive([]);
const arrMainTitle = reactive([]);
const i18n = useI18n();
const alertMessage = ref("null");
const alertState = ref("neutral");
const stationCode = store.getters.stationCode;
const userID = store.getters.cognitoUserName;

onMounted(function () {
  isLoading.value = true;
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  //【PermissionDetail】テーブルから詳細内容取得
  getPermissionDetailInfo();
});

/** 権限明細情報取得 */
const getPermissionDetailInfo = () => {
  isLoading.value = true;

  permissionDetail.splice(0);
  var data = {
    stationCode : store.getters.stationCode,
    department : store.getters.department
  }

  // get Permission Detail Information
  UserInfoDataService.getPermissionDetail(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          if (stationCode != "1000") {
            if (!info.SMCFlg) {
              permissionDetail.push(info);
            }
          } else {
            if(info.mainMenuCode != "MM0064"){
              permissionDetail.push(info);
            }
          }
        }
        filterPermissionDetailByMenuStationMapping();
      }
      getData.value = true;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const filterPermissionDetailByMenuStationMapping = () => {
  isLoading.value = true;
  var data = {
    stationCode : store.getters.stationCode,
    department : store.getters.department
  }

  UserInfoDataService.getMenuStationMapping(data)
    .then((response: ResponseData) => {
      const info = response.data;
      const result = permissionDetail.filter((menuInfo: any) => 
        info.some((item: any) => item.mainmenucode === menuInfo.mainMenuCode) &&
        !info.some(
          (item:any)=>
            item.mainmenucode === menuInfo.mainMenuCode &&
            item.stationcode === data.stationCode
        )
      );

      for (let i = permissionDetail.length - 1; i >= 0; i--) {
        if (result.some((r: any) => r.mainMenuCode === permissionDetail[i].mainMenuCode)) {
          permissionDetail.splice(i, 1);
        }
      }

      getUserPermissionDetailInfo();
    })
    .catch((e:Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
    })
    .finally(() => {
      isLoading.value = false;
    });
};

/** ユーザーが持つ権限明細情報取得 */
const getUserPermissionDetailInfo = () => {
  isLoading.value = true;
  cur_perm_list.splice(0);
  userPermissionInfo.splice(0);

  const data = { userId: userID };

  // get User Permission Information
  UserInfoDataService.getUserPermissionDetail(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          userPermissionInfo.push(info);
        }
      }
      statusPermisList.splice(0);
      for(let idxMenu of permissionDetail){
        var chkResult = userPermissionInfo.filter((permission: { mainMenuCode: any; }) => permission.mainMenuCode.mainMenuCode == idxMenu.mainMenuCode);
        if(chkResult.length == 0 || chkResult[0].status == "3"){
          statusPermisList.push("");
        }else if(chkResult[0].status == "1"){
          statusPermisList.push("waiting for node manager approval");
        }else if(chkResult[0].status == "2"){
          statusPermisList.push("waiting for SMC manager approval");
        }
      }
      checkCheckBox();
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err013");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const checkCheckBox = () => {
  // 対象ユーザーの為権限があるサブメニューにチェック付ける
  // 2023/04/17 MDCR 修正 start
  var mainMenuCode = "";
  var chkMainMenuCode = null;
  for (var info = 0; info < userPermissionInfo.length; info++) {
    mainMenuCode = userPermissionInfo[info].mainMenuCode.mainMenuCode;
    chkMainMenuCode = document.getElementById("chk" + mainMenuCode);
    if (userPermissionInfo[info].status == "3" && chkMainMenuCode) {
      // cur_perm_list.push((userPermissionInfo[info].mainMenuCode.mainMenuCode));
      // document.getElementById("chk" + userPermissionInfo[info].mainMenuCode.mainMenuCode).checked = true;
      cur_perm_list.push(mainMenuCode);
      chkMainMenuCode.checked = true;
    }
    if (
      userPermissionInfo[info].status == "2" ||
      (userPermissionInfo[info].status == "1" && chkMainMenuCode)
    ) {
      // document.getElementById("chk" + userPermissionInfo[info].mainMenuCode.mainMenuCode).disabled = true;
      // document.getElementById("chk" + userPermissionInfo[info].mainMenuCode.mainMenuCode).checked = false;
      chkMainMenuCode.disabled = true;
      chkMainMenuCode.checked = false;
    }
  }
  // 2023/04/17 MDCR 修正 end

  for (let j = 0; j < permissionDetail.length; j++) {
    if (
      j == 0 &&
      permissionDetail[j].mainTitleCode.mainTitleName ==
        permissionDetail[j + 1].mainTitleCode.mainTitleName
    ) {
      arrMainTitle.push(permissionDetail[j].mainTitleCode.mainTitleName);
    } else if (
      permissionDetail[j].mainMenuName != "" &&
      permissionDetail[j].mainTitleCode.mainTitleName !=
        permissionDetail[j - 1].mainTitleCode.mainTitleName
    ) {
      arrMainTitle.push(permissionDetail[j].mainTitleCode.mainTitleName);
    }
  }

  for (let k = 0; k < arrMainTitle.length; k++) {
    chkChange(arrMainTitle[k]);
  }
};

/** チェックボックス押下時の処理関数 */
const chkChange = (param) => {
  var chkHeaderID = "chkHeader" + param;
  var isHeaderCheck = true;
  var chkName = "chk" + param;
  var allChk = document.getElementsByName(chkName);
  // サブチェックボックスが【1】行以上ならヘッダチェックに反映する
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].checked == false) {
      isHeaderCheck = false;
    }
  }
  document.getElementById(chkHeaderID).checked = isHeaderCheck;
};

/** ヘッダチェックボックス変更 */
const chkHeaderChange = (param) => {
  var chkHeaderID = "chkHeader" + param;
  var chkName = "chk" + param;
  var isHeaderCheck = document.getElementById(chkHeaderID).checked;
  var allChk = document.getElementsByName(chkName);
  // 各チェック未チェックの反映
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].disabled == false) {
      allChk[i].checked = isHeaderCheck;
    }
  }
};

const insertUserPermission = () => {
  isLoading.value = true;
  reapp_perm_list.splice(0);

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  var permissiontbl = document.getElementById("permissiontbl");
  const totalMenu = permissiontbl.rows.length;
  var checkboxList = document.getElementsByName("chkHeader");
  const titleLen = checkboxList.length;

  for (let i = 0; i < totalMenu - titleLen; i++) {
    const chkFlg = document.getElementById(
      "chk" + permissionDetail[i].mainMenuCode
    );
    if (chkFlg.checked == true) {
      reapp_perm_list.push(permissionDetail[i].mainMenuCode);
    }
  }

  UserInfoDataService.insertUpdatedUserPermissionData(
    userID,
    cur_perm_list,
    reapp_perm_list,
    stationCode
  )
    .then((response: ResponseData) => {
      // 2023/05/18 MDCR 修正 start(拠点管理者・SMC管理者へメール通知)
      if (response.data.changesFlg == "0") {
        alertMessage.value = i18n.t("suc031");
        alertState.value = "success";
        isLoading.value = false;
      } else if(response.data.mailSendFlg != "0") {
        if (response.data.mailSendFlg == "1") {
          // SMC管理者へメール送信
          const menuData ={
            userId: userID, 
            menuList : response.data.menuList
          };
          SendEmailService.sendEmailByMenu(menuData)
            .then((response2: ResponseData) => {
              if (response2.data.length != 0) {
                for (var i = 0; i < response2.data.length; i ++) {                
                  const smcData ={
                    userId: userID, 
                    targetMailFormat: "mail_SMC_manager_notice", 
                    sendingPattern: "SMC_manager_notice", 
                    email: response2.data[i]['email'],
                    menuList: response2.data[i]['menuList'],
                    loginUserId: store.getters.cognitoUserName
                  };

                  SendEmailService.sendEmail(smcData)
                  .catch((e: Error) => {
                    alertMessage.value = "Fail to send notice email of permission approval";
                    alertState.value = "error";
                    console.log(e);
                  });
                }
              }
              getPermissionDetailInfo();
              alertMessage.value = i18n.t("suc030");
              alertState.value = "success";
              isLoading.value = false;
          })
          .catch((e: Error) => {
            alertMessage.value = "Fail to send notice email of permission approval";
            alertState.value = "error";
            console.log(e);
          });
        }else if (response.data.mailSendFlg == "2"){
          const data ={
            stationCode: stationCode,
            targetMailFormat: "mail_node_manager_notice", 
            sendingPattern: "kyoten_notice", 
            menuList: response.data.menuList,
            loginUserId: store.getters.cognitoUserName
          };
          SendEmailService.sendEmail(data)
          .then((response2: ResponseData) => {
            getPermissionDetailInfo();
            alertMessage.value = i18n.t("suc030");
            alertState.value = "success";
            isLoading.value = false;
          })
          .catch((e: Error) => {
            alertMessage.value = "Fail to send notice email of menu permission approval";
            alertState.value = "error";
            console.log(e);
          }); 
        }
      }else{
        // 既にあるメニュー権限を削除するだけの場合、メール通知なしにする
        getPermissionDetailInfo();
        alertMessage.value = i18n.t("suc030");
        alertState.value = "success";
        isLoading.value = false;
      }
      // 2023/05/18 MDCR 修正 end
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err024");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

onUpdated(function () {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("usertbltbody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("usermydiv")?.clientHeight;
      if (dataHeight < tableHeight) {
        document.getElementById("usertblbodydiv").style.width = "100%";
      } else {
        document.getElementById("usertblbodydiv").style.width =
          "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
  isLoading.value = false;
});

const __returned__ = { getData, isLoading, permissionDetail, cur_perm_list, reapp_perm_list, userPermissionInfo, statusPermisList, arrMainTitle, i18n, alertMessage, alertState, stationCode, userID, getPermissionDetailInfo, filterPermissionDetailByMenuStationMapping, getUserPermissionDetailInfo, checkCheckBox, chkChange, chkHeaderChange, insertUserPermission, UserLinkNavigation, Alert, Navigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})